<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.order-search')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <search-buttons @includeCancel="includeCancel" @search="onSearch"/>
          <template v-if="isLoad">
            <b-row>
              <b-colxx xxs="12">
                <b-table
                  head-variant="light"
                  ref="general-table"
                  class="vuetable"
                  id="table-transition-example"
                  :items="items"
                  align="center"
                  :fields="fields"
                  :per-page="perPage"
                  primary-key="bookingId"
                  responsive
                  show-empty>
                  <!-- :current-page="currentPage" -->

                  <template v-slot:cell(orderNo)="row">
                    <router-link :to="`order-detail/${row.item.orderNo}`" class="cls_click">
                      {{row.item.orderNo}}
                    </router-link>
                  </template>
                  <template v-slot:cell(salePrice)="row">
                    {{row.item.salePrice | currency}}
                  </template>
                  <template v-slot:cell(orderStatus)="row">
                    <span :style="statusColor(row.item.orderStatus)">{{getOrderStatusText(row.item.orderStatus)}}</span>
                  </template>
                  <template v-slot:cell(agentPaymentMethod)="row">
                    {{getAgentPaymentMethodText(row.item.agentPaymentMethod)}}
                  </template>
                  <template v-slot:cell(purchaseDate)="row">
                    {{$moment(row.item.purchaseDate).format('YYYY-MM-DD')}}
                  </template>
                  <template v-slot:cell(channelName)="row">
                    {{ row.item.channelName == "tablenjoy" ? "온라인" : "외부채널"}}
                  </template>
                  <template v-slot:cell(cancel_date)="row">
                    <!--                    {{$moment(row.item.cancel_date).format('YYYY-MM-DD')}}-->
                  </template>

                  <template v-slot:empty="row">
                    <h6 style="text-align: center;font-weight: lighter">해당 주문 내역이 없습니다.</h6>
                  </template>

                  <!--메모-->
                  <template v-slot:cell(memo)="row">
                    <b-button variant="primary default" size="sm" @click="ShowMemo(row.item)">
                      <i class="simple-icon-notebook"/>
                    </b-button>
                  </template>


                </b-table>


                <b-pagination
                  v-if="lastPage > 1"
                  size="sm"
                  align="center"
                  :total-rows="total"
                  :per-page="perPage"
                  v-model="currentPage"
                >
                  <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                  </template>
                  <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                  </template>
                  <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                  </template>
                  <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                  </template>
                </b-pagination>

              </b-colxx>
            </b-row>
          </template>
          <template v-else>
            <div class="loading"></div>
          </template>


          <!--메모 모달-->
          <b-modal id="modalMemo" ref="modalMemo" title="메모입력">
            <b-textarea v-model="textMemo" :rows="7"/>
            <template slot="modal-footer">
              <b-button variant="primary" @click="putMemo" class="mr-1">저장</b-button>
              <b-button variant="secondary" @click="hideModal">닫기</b-button>
            </template>
          </b-modal>


        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";

  import 'vue-select/dist/vue-select.css'
  import vSelect from 'vue-select'
  import api from '../../constants/api'
  import {
    alignTableCenter,
    currencyFilter,
    getOrderStatusText,
    getAgentPaymentMethodText,
  } from "../../utils";
  import '../../assets/css/custom/common.css'
  import SearchButtons from './components/SearchButtons'


  export default {
    components: {
      'v-select': vSelect,
      'search-buttons': SearchButtons,
    },
    filters: {...currencyFilter},
    data() {
      return {
        isLoad: false,
        currentPage: 1,
        perPage: 10,
        pageSize: [],
        includeCancelItem: true,
        total: 0,
        lastPage: 0,
        searchValue: {
          searchKind: 'OrderNo',
          searchKeyword: "",
          startDate: this.$moment(new Date()).subtract('day', 14).toString(),
          endDate: this.$moment(new Date()).add('day', 14).toDate(),
        },
        fields: [
          {key: "selected", label: "", ...alignTableCenter},
          {key: 'orderNo', label: '주문번호', ...alignTableCenter},
          {key: 'goodsName', label: '상품명', thClass: "mw150", ...alignTableCenter},
          {key: 'itemCount', label: '구매', ...alignTableCenter},
          {key: 'salePrice', label: '결제금액', ...alignTableCenter},
          {key: 'username', label: '사용자ID', ...alignTableCenter},
          {key: 'buyerName', label: '구매자', ...alignTableCenter},
          {key: 'agentPaymentMethod', label: '결제방법', ...alignTableCenter},
          {key: 'orderStatus', label: '주문상태', ...alignTableCenter},
          {key: 'purchaseDate', label: '주문일', ...alignTableCenter},
          {key: 'cancel_date', label: '취소일', ...alignTableCenter},
          {key: 'channelName', label: '주문경로', ...alignTableCenter},
          {key: 'memo', label: '메모', ...alignTableCenter},
        ],
        items: [],
        textMemo: "",
        selected_order_no: null
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },

    mounted() {
      this.searchData()
    },

    watch: {
      currentPage(value) {
        this.searchData();
      }
    },

    methods: {
      getOrderStatusText,
      getAgentPaymentMethodText,

      refreshStatus(e) {
      },

      /** *************************************************************************************************************/
      /** 주문내역조회 리스트 ******************************************************************************************/
      /** *************************************************************************************************************/

      includeCancel(flag) {
        this.searchValue.includeCancel = flag
      },

      searchData() {
        this.isLoad = false
        this.items = []

        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.orderList)
        const _keywordType = this.searchValue.searchKeyword === "" ? "NoKeyword" : this.searchValue.searchKind

        let orderStatus = null
        console.log(this.searchValue.includeCancel)
        if(this.searchValue.includeCancel == true) { //취소건 포함
          orderStatus = {
            all: true,
            purchased: true,
            cancelRequested: true,
            cancelled: true,
            needsPayment: true
          }
        } else { //취소건미포함
          orderStatus = {
            all: false,
            purchased: true,
            cancelRequested: false,
            cancelled: false,
            needsPayment: true
          }
        }

        const params = {
          dateFrom: this.$moment(this.searchValue.startDate).format('YYYY-MM-DD').toString(),
          dateTo: this.$moment(this.searchValue.endDate).format('YYYY-MM-DD').toString(),
          pageNumber: this.currentPage - 1,
          pageSize: this.perPage,
          keywordType: _keywordType,
          keyword: this.searchValue.searchKeyword,
          orderStatus: orderStatus
        }

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            

            let _data = res.data.data
            this.lastPage = _data.totalPages
            this.total = _data.totalElements
            this.items = _data.content
            this.isLoad = true


          } else {
            throw 400
          }
        }).catch(err => {
          alert('주문내역을 불러오지못했습니다.')
          this.isLoad = true
        })
      },


      statusColor(status_order) {
        let color = 'color:black'
        if(status_order === "Cancelled") {
          color = 'color:red'
        } else if(status_order === "CancelRequested") {
          color = 'color:blue'
        } else if(status_order === "CancelFailed") {
          color = 'color:green'
        } else if(status_order === "Purchased") {
          color = 'color:black'
        }
        return color
      },

      /** *************************************************************************************************************/
      /** 메모저장 ****************************************************************************************************/
      /** *************************************************************************************************************/
      putMemo() {
        if(this.textMemo == "") {
          alert('메모를 입력해주세요')
          return false
        }
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.orderSaveMemo)
        const params = {
          orderNo: this.selected_order_no,
          memo: this.textMemo
        }
        // console.log(params)

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            alert('저장되었습니다');
            this.hideModal()
            this.searchData()
          } else {
            throw 400
          }
        }).catch(err => {
          alert('메모를 저장하지 못했습니다.')
          this.hideModal()
        })
        this.selected_order_no = null
      },

      ShowMemo(item) {
        this.selected_order_no = item.orderNo
        this.textMemo = item.memo
        this.$refs['modalMemo'].show()
      },
      hideModal() {
        this.selected_order_no = null
        this.$refs['modalMemo'].hide()
      },
      onSearch(searchValue) {
        this.searchValue = searchValue
        this.searchData()
      }
    }
  }

</script>
